// extracted by mini-css-extract-plugin
export default {"heading":"Dashboard_heading__m2DDW","grid":"Dashboard_grid__P0kJv","card":"Dashboard_card__8MBZx","progress":"Dashboard_progress__Frrzl","bar":"Dashboard_bar__l+HcB"};